
import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { CommonService } from '../../../service/common.service';
import { Articolo } from '../../../models/articolo';
import { Catalogo } from '../../../models/catalogo';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { configurazione } from '../../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Richiestaordinazionearticolo } from '../../../models/richiestaordinazionearticolo';

  

@Component({
  selector: 'app-articolitabs',
  templateUrl: './articolitabs.component.html',
  styleUrls: ['./articolitabs.component.css']
})
export class ArticolitabsComponent implements OnInit {
  selectedValueCatalogo:string;
  articoli: Articolo[]=[];
  articolidaordinare: Richiestaordinazionearticolo[]=[];
  articolidaconsegnare: Richiestaordinazionearticolo[]=[];

  cataloghi: Catalogo[];
  catalogo: Catalogo;
  filtroCodicearticolo:string="";
  filtroDescrizione:string="";
  filtroLte:string="";
  filtroGte:string="";
  filtroOnlyInStock:boolean=false;
  totalElements:number=0;
  totalPages:number=0;
  currentPage:number=1;
//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "Id",
    "Catalogo",
    "Codicecatalogo",
    "Codicearticolo",
    "Descrizione",
    "Categoria",
    "Costo",
    "Iva",
    "Prezzo",
    "Note",
    "Giacenza",
    "Unitamisura",
    "edit",
    "Quantitarichiesta",
    "shoppingcart"];

    displayedColumns2: string[] = [
      "Codicearticolo",
      "Datarichiesta",
      "Dataordine",
      "Dataconsegna",
      "Quantitarichiesta",
      "Quantitaordinata",
      "Quantitaconsegnata",
      "save"];

      displayedColumns3: string[] = [
        "Codicearticolo",
        "Datarichiesta",
        "Dataordine",
        "Dataconsegna",
        "Quantitarichiesta",
        "Quantitaordinata",
        "Quantitaconsegnata",
        "save"];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();
  dataSource = new MatTableDataSource<Articolo>(this.articoli);
  dataSource2 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaordinare);
  dataSource3 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaconsegnare);
  @Input() tab : string;



  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit() {

    this.commonService.getAllCataloghi().subscribe((res) => {
        this.cataloghi = res;

/*
        this.commesse.forEach(element => {
          if (element.Codice === this.commonService.currentAziendaCodice){
            this.stato=element;
            this.selectedValueAzienda=this.azienda.Nome;
          }
        });
*/
  //      this.manageChangeAzienda();
        

        this.commonService.getAllArticolidaordinare().subscribe((res1) => {
            this.articolidaordinare = res1;
            this.dataSource2 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaordinare);
            this.commonService.getAllArticolidaconsegnare().subscribe((res2) => {
                   this.articolidaconsegnare=res2;
                   this.dataSource3 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaconsegnare);
            });
           //this.manageChangeCatalogo();
           if (this.commonService.selectedCatalogo!=undefined){
            this.catalogo=this.commonService.selectedCatalogo;
            this.commonService.selectedCatalogo=undefined;
 //           this.selectedValueCatalogo=this.commonService.selectedCatalogo.Nome;
//            this.commonService.getAllArticoli(this.commonService.selectedCatalogo.Codice).subscribe((res3) => {
//              this.articoli=res3;
              this.aggiornaLista();
 //           });
          }
    });


  //  this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Id",true);
    this.sortedDirection.set("Catalogo",true);
    this.sortedDirection.set("Codicecatalogo",true);
    this.sortedDirection.set("Codicearticolo",true);
    this.sortedDirection.set("Descrizione",true);
    this.sortedDirection.set("Categoria",true);
    this.sortedDirection.set("Costo",true);
    this.sortedDirection.set("Iva",true);
    this.sortedDirection.set("Prezzo",true);
    this.sortedDirection.set("Note",true);
    this.sortedDirection.set("Giacenza",true);
    this.sortedDirection.set("Unitamisura",true);
  });
}
  manageChangeCatalogo(){
    if (this.selectedValueCatalogo===undefined){
     return;
    }
    this.cataloghi.forEach(element => {
      if (this.selectedValueCatalogo === element.Nome){
        this.catalogo=element;
      }
    });
    this.aggiornaLista();
  }

  cancel(){
    this.selectedValueCatalogo="";
    this.catalogo=new Catalogo();
    this.filtroLte="";
    this.filtroGte="";
    this.aggiornaLista();
  }



  delete(articolo: Articolo): void {
    this.commonService.deleteArticolo(articolo).subscribe(data => {
      this.articoli = this.articoli.filter(c => c !== articolo);
    });
  }


  aggiornaLista(){
    this.articoli=[];
      if (this.catalogo!=undefined){
       this.commonService.getAllArticoliByCatalogo(this.catalogo.Codice).subscribe((res) => {
           this.articoli=res.slice(0,10);
           this.totalPages=Math.ceil(res.length/10);
           this.totalElements=res.length;
           this.refreshLista(this.articoli);
        });
      }
    }

  refreshArticolidaordinare(){
      this.articolidaordinare=[];
         this.commonService.getAllArticolidaordinare().subscribe((res) => {
             this.articolidaordinare=res;
             this.dataSource2 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaordinare);
          });

    }

  refreshArticolidaconsegnare(){
      this.articolidaconsegnare=[];
         this.commonService.getAllArticolidaconsegnare().subscribe((res) => {
             this.articolidaconsegnare=res;
             this.dataSource3 = new MatTableDataSource<Richiestaordinazionearticolo>(this.articolidaconsegnare);
          });

    }

   refreshLista(listaarticoli:Articolo[]){
     this.articoli=listaarticoli;
     this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
   }

  new(){
    this.commonService.selectedArticolo=undefined;
    this.commonService.selectedCatalogo=this.catalogo;
    this.router.navigate(['addarticolo']);
  }
  edit(articolo: Articolo): void {
      this.commonService.selectedArticolo=articolo;
      this.commonService.selectedCatalogo=articolo.Catalogo;
      this.router.navigate(['addarticolo']);
  }

  goPrevPage(){
    if (this.currentPage>1){
      this.currentPage--;
      this.cerca();
    }
  }

  goNextPage(){
    if (this.currentPage<this.totalPages){
      this.currentPage++;
      this.cerca();
    }
  }

  cerca(){

    let testo=this.filtroCodicearticolo+this.filtroDescrizione;
      let searchPage=0;
      if (this.currentPage>0){
        searchPage=this.currentPage-1;
      }

      this.commonService.getArticolisearch(true, searchPage, 10, testo, Number(this.filtroLte), Number(this.filtroGte), false).subscribe(res=>{
        this.articoli=res;

        this.commonService.getArticoliSize(testo).subscribe(data=>{
          this.totalPages=data['totalPages'];
          this.totalElements=data['totalElements'];
          console.log("--->"+data['totalPages']);
          console.log("--->"+data['totalElements']);
        })


        this.refreshLista(this.articoli);

      })
  }

  onFiltroCodicearticoloKeyup(event:any){
    this.filtroDescrizione="";
  }

  onFiltroDescrizioneKeyup(event:any){
    this.filtroCodicearticolo="";
  }

  onFiltroLteKeyup(event:any){
    if (isNaN(event.target.value)){
      event.target.value=this.filtroLte;
    }else{
      this.filtroLte=event.target.value;
    }

  }

  onFiltroGteKeyup(event:any){
    if (isNaN(event.target.value)){
      event.target.value=this.filtroGte;
    }else{
      this.filtroGte=event.target.value;
    }
  }

  onFiltroOnlyInStockKeyup(event:any){
    this.filtroOnlyInStock=event.checked;
  }

  getConfigurazione(){
    return configurazione.articolo;
  }

  manageClick(attributo: string){
    let tempList:Articolo[];
    tempList=this.articoli;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Articolo>(this.articoli);

   }


  onQuantitarichiestaArticoloKeyup(a: Articolo, event: any) {
    if (isNaN(event.target.value)) {
      event.target.value = a.Quantitarichiesta;
    } else {
      a.Quantitarichiesta = Number(event.target.value);
    }
  }

   onQuantitarichiestaKeyup(a:Richiestaordinazionearticolo, event:any){
     if (isNaN(event.target.value)){
       event.target.value=a.Quantitarichiesta;
     }else{
       a.Quantitarichiesta=Number(event.target.value);
     }
   }

   onQuantitaordinataKeyup(a:Richiestaordinazionearticolo, event:any){
     if (isNaN(event.target.value)){
       event.target.value=a.Quantitaordinata;
     }else{
       a.Quantitaordinata=Number(event.target.value);
     }
   }

   onQuantitaconsegnataKeyup(a:Richiestaordinazionearticolo, event:any){
     if (isNaN(event.target.value)){
       event.target.value=a.Quantitaconsegnata;
     }else{
       a.Quantitaconsegnata=Number(event.target.value);
     }
   }

  saveArticolorichiesto(a:Articolo){
     let riord:Richiestaordinazionearticolo=new Richiestaordinazionearticolo();
     riord.Articolo=new Articolo();
     riord.Articolo=a;
     riord.Datarichiesta=new Date();
     riord.Quantitarichiesta=a.Quantitarichiesta;

     this.commonService.saveArticolodaordinare(riord).subscribe((data) => {

       let rc: number;
       rc=Number(JSON.stringify(data));
       if (rc>0){
         alert("Articolo da ordinare salvato con successo: inserito negli articoli da ordinare.");
         this.refreshArticolidaordinare();
         a.Quantitarichiesta=undefined
       }else if (rc===-1){
         alert("Errore salvataggio articolo da ordinare");
       } else if (rc === -2) {
         alert("Errore articolo già richiesto");
       }
     });
   }
  saveArticolodaordinare(riord: Richiestaordinazionearticolo) {
    riord.Dataordine = new Date();

    this.commonService.saveArticolodaordinare(riord).subscribe((data) => {

      let rc: number;
      rc = Number(JSON.stringify(data));
      if (rc > 0) {
        alert("Articolo da ordinare salvato con successo: inserito negli articoli da consegnare.");
        this.refreshArticolidaordinare();
      } else if (rc === -1) {
        alert("Errore salvataggio articolo da ordinare");
      } 

    });
  }
  saveArticoloconsegnato(riord: Richiestaordinazionearticolo) {
    riord.Dataconsegna = new Date();

    this.commonService.saveArticolodaordinare(riord).subscribe((data) => {

      let rc: number;
      rc = Number(JSON.stringify(data));
      if (rc > 0) {
        alert("Articolo da consegnare salvato con successo: aggiornata la giacenza.");
        this.refreshArticolidaconsegnare();
      } else if (rc === -1) {
        alert("Errore salvataggio articolo da ordinare");
      }

    });
  }
  isReadonlyArticolorichiesto(a: Articolo) {
    return a.Quantitarichiesta === undefined || a.Quantitarichiesta == 0;
  }
  isReadonlyArticolodaordina(r: Richiestaordinazionearticolo) {
    return r.Quantitaordinata === undefined || r.Quantitaordinata == 0;
  } 
  isReadonlyArticoloconsegnato(r: Richiestaordinazionearticolo) {
    return (r.Quantitaconsegnata === undefined || r.Quantitaconsegnata == 0)&&(r.Dataconsegna===null);
  }
}
